/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BasicShopStatistics,
  CampaignMoneyGraphData,
  CampaignNumberGraphData,
  CountryPaymentAndShippingStatistics,
  CouponPerformance,
  CouponStats,
  DailyCountryData,
  DailyOverviewData,
  DailyPaymentData,
  DailyShippingData,
  DateRangeInput,
  DateRangeOrdersGranular,
  DayInput,
  DiscountPerformance,
  ErpFilter,
  ErrorResponse,
  ProductPerformanceDayInput,
  ProductPerformanceFilter,
  ShopPerformance,
  ShopPerformancePno,
  StatisticsBySource,
  TopChannelsData,
  TopProductData,
} from '../models/index';
import {
    BasicShopStatisticsFromJSON,
    BasicShopStatisticsToJSON,
    CampaignMoneyGraphDataFromJSON,
    CampaignMoneyGraphDataToJSON,
    CampaignNumberGraphDataFromJSON,
    CampaignNumberGraphDataToJSON,
    CountryPaymentAndShippingStatisticsFromJSON,
    CountryPaymentAndShippingStatisticsToJSON,
    CouponPerformanceFromJSON,
    CouponPerformanceToJSON,
    CouponStatsFromJSON,
    CouponStatsToJSON,
    DailyCountryDataFromJSON,
    DailyCountryDataToJSON,
    DailyOverviewDataFromJSON,
    DailyOverviewDataToJSON,
    DailyPaymentDataFromJSON,
    DailyPaymentDataToJSON,
    DailyShippingDataFromJSON,
    DailyShippingDataToJSON,
    DateRangeInputFromJSON,
    DateRangeInputToJSON,
    DateRangeOrdersGranularFromJSON,
    DateRangeOrdersGranularToJSON,
    DayInputFromJSON,
    DayInputToJSON,
    DiscountPerformanceFromJSON,
    DiscountPerformanceToJSON,
    ErpFilterFromJSON,
    ErpFilterToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ProductPerformanceDayInputFromJSON,
    ProductPerformanceDayInputToJSON,
    ProductPerformanceFilterFromJSON,
    ProductPerformanceFilterToJSON,
    ShopPerformanceFromJSON,
    ShopPerformanceToJSON,
    ShopPerformancePnoFromJSON,
    ShopPerformancePnoToJSON,
    StatisticsBySourceFromJSON,
    StatisticsBySourceToJSON,
    TopChannelsDataFromJSON,
    TopChannelsDataToJSON,
    TopProductDataFromJSON,
    TopProductDataToJSON,
} from '../models/index';

export interface ChannelPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ClicksInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface CouponPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface CpcInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface DailyCountryPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyCouponPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyOrderPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyPaymentPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyProductPerformanceRequest {
    projectId: string;
    productPerformanceDayInput?: ProductPerformanceDayInput;
}

export interface DailyShippingPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DailyTopChannelPerformanceRequest {
    projectId: string;
    dayInput?: DayInput;
}

export interface DiscountPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrderOverviewRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface OrdersInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface PnoInTimeRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ProductPerformanceRequest {
    projectId: string;
    productPerformanceFilter?: ProductPerformanceFilter;
}

export interface ShopBasicStatisticsRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopChannelsStatisticsBySourceRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface ShopCountryPaymentAndShippingStatisticsRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

export interface ShopPerformanceRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOChannelsOnlyRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOTotalRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopPerformancePNOTotalWithoutOfflineRequest {
    projectId: string;
    erpFilter?: ErpFilter;
}

export interface ShopTurnoverByDomainStatisticsRequest {
    projectId: string;
    dateRangeInput?: DateRangeInput;
}

/**
 * 
 */
export class ErpCalculationApi extends runtime.BaseAPI {

    /**
     * Creates request options for channelPerformance without sending the request
     */
    async channelPerformanceRequestOpts(requestParameters: ChannelPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling channelPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/channel-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns top channels data.
     */
    async channelPerformanceRaw(requestParameters: ChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopChannelsData>> {
        const requestOptions = await this.channelPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopChannelsDataFromJSON(jsonValue));
    }

    /**
     * Returns top channels data.
     */
    async channelPerformance(requestParameters: ChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopChannelsData> {
        const response = await this.channelPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for clicksInTime without sending the request
     */
    async clicksInTimeRequestOpts(requestParameters: ClicksInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling clicksInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/clicks-in-time`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async clicksInTimeRaw(requestParameters: ClicksInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.clicksInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async clicksInTime(requestParameters: ClicksInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.clicksInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for couponPerformance without sending the request
     */
    async couponPerformanceRequestOpts(requestParameters: CouponPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling couponPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/coupon-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data.
     */
    async couponPerformanceRaw(requestParameters: CouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CouponPerformance>> {
        const requestOptions = await this.couponPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CouponPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns data.
     */
    async couponPerformance(requestParameters: CouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CouponPerformance> {
        const response = await this.couponPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for cpcInTime without sending the request
     */
    async cpcInTimeRequestOpts(requestParameters: CpcInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling cpcInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/cpc-in-time`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async cpcInTimeRaw(requestParameters: CpcInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignMoneyGraphData>> {
        const requestOptions = await this.cpcInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignMoneyGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async cpcInTime(requestParameters: CpcInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignMoneyGraphData> {
        const response = await this.cpcInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyCountryPerformance without sending the request
     */
    async dailyCountryPerformanceRequestOpts(requestParameters: DailyCountryPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyCountryPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-country-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dailyCountryPerformanceRaw(requestParameters: DailyCountryPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyCountryData>> {
        const requestOptions = await this.dailyCountryPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyCountryDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dailyCountryPerformance(requestParameters: DailyCountryPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyCountryData> {
        const response = await this.dailyCountryPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyCouponPerformance without sending the request
     */
    async dailyCouponPerformanceRequestOpts(requestParameters: DailyCouponPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyCouponPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-coupons-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dailyCouponPerformanceRaw(requestParameters: DailyCouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<CouponStats>>> {
        const requestOptions = await this.dailyCouponPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CouponStatsFromJSON));
    }

    /**
     * Returns data file uri.
     */
    async dailyCouponPerformance(requestParameters: DailyCouponPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<CouponStats>> {
        const response = await this.dailyCouponPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyOrderPerformance without sending the request
     */
    async dailyOrderPerformanceRequestOpts(requestParameters: DailyOrderPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyOrderPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-order-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns data file uri.
     */
    async dailyOrderPerformanceRaw(requestParameters: DailyOrderPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyOverviewData>> {
        const requestOptions = await this.dailyOrderPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyOverviewDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async dailyOrderPerformance(requestParameters: DailyOrderPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyOverviewData> {
        const response = await this.dailyOrderPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyPaymentPerformance without sending the request
     */
    async dailyPaymentPerformanceRequestOpts(requestParameters: DailyPaymentPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyPaymentPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-payment-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns payment data.
     */
    async dailyPaymentPerformanceRaw(requestParameters: DailyPaymentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyPaymentData>> {
        const requestOptions = await this.dailyPaymentPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyPaymentDataFromJSON(jsonValue));
    }

    /**
     * Returns payment data.
     */
    async dailyPaymentPerformance(requestParameters: DailyPaymentPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyPaymentData> {
        const response = await this.dailyPaymentPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyProductPerformance without sending the request
     */
    async dailyProductPerformanceRequestOpts(requestParameters: DailyProductPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyProductPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-product-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductPerformanceDayInputToJSON(requestParameters['productPerformanceDayInput']),
        };
    }

    /**
     * Product performance data.
     */
    async dailyProductPerformanceRaw(requestParameters: DailyProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopProductData>> {
        const requestOptions = await this.dailyProductPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopProductDataFromJSON(jsonValue));
    }

    /**
     * Product performance data.
     */
    async dailyProductPerformance(requestParameters: DailyProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopProductData> {
        const response = await this.dailyProductPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyShippingPerformance without sending the request
     */
    async dailyShippingPerformanceRequestOpts(requestParameters: DailyShippingPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyShippingPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-shipping-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns payment data.
     */
    async dailyShippingPerformanceRaw(requestParameters: DailyShippingPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DailyShippingData>> {
        const requestOptions = await this.dailyShippingPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DailyShippingDataFromJSON(jsonValue));
    }

    /**
     * Returns payment data.
     */
    async dailyShippingPerformance(requestParameters: DailyShippingPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DailyShippingData> {
        const response = await this.dailyShippingPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for dailyTopChannelPerformance without sending the request
     */
    async dailyTopChannelPerformanceRequestOpts(requestParameters: DailyTopChannelPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling dailyTopChannelPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/daily-top-channels-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DayInputToJSON(requestParameters['dayInput']),
        };
    }

    /**
     * Returns top channel data.
     */
    async dailyTopChannelPerformanceRaw(requestParameters: DailyTopChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopChannelsData>> {
        const requestOptions = await this.dailyTopChannelPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopChannelsDataFromJSON(jsonValue));
    }

    /**
     * Returns top channel data.
     */
    async dailyTopChannelPerformance(requestParameters: DailyTopChannelPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopChannelsData> {
        const response = await this.dailyTopChannelPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for discountPerformance without sending the request
     */
    async discountPerformanceRequestOpts(requestParameters: DiscountPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling discountPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/discount-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data.
     */
    async discountPerformanceRaw(requestParameters: DiscountPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DiscountPerformance>> {
        const requestOptions = await this.discountPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DiscountPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns data.
     */
    async discountPerformance(requestParameters: DiscountPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DiscountPerformance> {
        const response = await this.discountPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for orderOverview without sending the request
     */
    async orderOverviewRequestOpts(requestParameters: OrderOverviewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling orderOverview().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/order-overview`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async orderOverviewRaw(requestParameters: OrderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DateRangeOrdersGranular>> {
        const requestOptions = await this.orderOverviewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DateRangeOrdersGranularFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async orderOverview(requestParameters: OrderOverviewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DateRangeOrdersGranular> {
        const response = await this.orderOverviewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for ordersInTime without sending the request
     */
    async ordersInTimeRequestOpts(requestParameters: OrdersInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling ordersInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/orders-in-time`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async ordersInTimeRaw(requestParameters: OrdersInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.ordersInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async ordersInTime(requestParameters: OrdersInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.ordersInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for pnoInTime without sending the request
     */
    async pnoInTimeRequestOpts(requestParameters: PnoInTimeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling pnoInTime().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/pno-in-time`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns data file uri.
     */
    async pnoInTimeRaw(requestParameters: PnoInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CampaignNumberGraphData>> {
        const requestOptions = await this.pnoInTimeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CampaignNumberGraphDataFromJSON(jsonValue));
    }

    /**
     * Returns data file uri.
     */
    async pnoInTime(requestParameters: PnoInTimeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CampaignNumberGraphData> {
        const response = await this.pnoInTimeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for productPerformance without sending the request
     */
    async productPerformanceRequestOpts(requestParameters: ProductPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling productPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/product-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ProductPerformanceFilterToJSON(requestParameters['productPerformanceFilter']),
        };
    }

    /**
     * Product performance data.
     */
    async productPerformanceRaw(requestParameters: ProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<TopProductData>> {
        const requestOptions = await this.productPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => TopProductDataFromJSON(jsonValue));
    }

    /**
     * Product performance data.
     */
    async productPerformance(requestParameters: ProductPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<TopProductData> {
        const response = await this.productPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopBasicStatistics without sending the request
     */
    async shopBasicStatisticsRequestOpts(requestParameters: ShopBasicStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopBasicStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/basic`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopBasicStatisticsRaw(requestParameters: ShopBasicStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BasicShopStatistics>> {
        const requestOptions = await this.shopBasicStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BasicShopStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopBasicStatistics(requestParameters: ShopBasicStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BasicShopStatistics> {
        const response = await this.shopBasicStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopChannelsStatisticsBySource without sending the request
     */
    async shopChannelsStatisticsBySourceRequestOpts(requestParameters: ShopChannelsStatisticsBySourceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopChannelsStatisticsBySource().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/statistics-by-source`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopChannelsStatisticsBySourceRaw(requestParameters: ShopChannelsStatisticsBySourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StatisticsBySource>> {
        const requestOptions = await this.shopChannelsStatisticsBySourceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StatisticsBySourceFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopChannelsStatisticsBySource(requestParameters: ShopChannelsStatisticsBySourceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StatisticsBySource> {
        const response = await this.shopChannelsStatisticsBySourceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopCountryPaymentAndShippingStatistics without sending the request
     */
    async shopCountryPaymentAndShippingStatisticsRequestOpts(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopCountryPaymentAndShippingStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/country-payment-shipping`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopCountryPaymentAndShippingStatisticsRaw(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CountryPaymentAndShippingStatistics>> {
        const requestOptions = await this.shopCountryPaymentAndShippingStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CountryPaymentAndShippingStatisticsFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopCountryPaymentAndShippingStatistics(requestParameters: ShopCountryPaymentAndShippingStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CountryPaymentAndShippingStatistics> {
        const response = await this.shopCountryPaymentAndShippingStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformance without sending the request
     */
    async shopPerformanceRequestOpts(requestParameters: ShopPerformanceRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformance().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopPerformanceRaw(requestParameters: ShopPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformance>> {
        const requestOptions = await this.shopPerformanceRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformanceFromJSON(jsonValue));
    }

    /**
     * Returns shop performance data.
     */
    async shopPerformance(requestParameters: ShopPerformanceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformance> {
        const response = await this.shopPerformanceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformancePNOChannelsOnly without sending the request
     */
    async shopPerformancePNOChannelsOnlyRequestOpts(requestParameters: ShopPerformancePNOChannelsOnlyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOChannelsOnly().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance-pno/channels-only`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOChannelsOnlyRaw(requestParameters: ShopPerformancePNOChannelsOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        const requestOptions = await this.shopPerformancePNOChannelsOnlyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOChannelsOnly(requestParameters: ShopPerformancePNOChannelsOnlyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOChannelsOnlyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformancePNOTotal without sending the request
     */
    async shopPerformancePNOTotalRequestOpts(requestParameters: ShopPerformancePNOTotalRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOTotal().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance-pno/total`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalRaw(requestParameters: ShopPerformancePNOTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        const requestOptions = await this.shopPerformancePNOTotalRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotal(requestParameters: ShopPerformancePNOTotalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOTotalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopPerformancePNOTotalWithoutOffline without sending the request
     */
    async shopPerformancePNOTotalWithoutOfflineRequestOpts(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopPerformancePNOTotalWithoutOffline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-performance-pno/total-without-offline`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ErpFilterToJSON(requestParameters['erpFilter']),
        };
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalWithoutOfflineRaw(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ShopPerformancePno>> {
        const requestOptions = await this.shopPerformancePNOTotalWithoutOfflineRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ShopPerformancePnoFromJSON(jsonValue));
    }

    /**
     * Returns pno data.
     */
    async shopPerformancePNOTotalWithoutOffline(requestParameters: ShopPerformancePNOTotalWithoutOfflineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ShopPerformancePno> {
        const response = await this.shopPerformancePNOTotalWithoutOfflineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for shopTurnoverByDomainStatistics without sending the request
     */
    async shopTurnoverByDomainStatisticsRequestOpts(requestParameters: ShopTurnoverByDomainStatisticsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['projectId'] == null) {
            throw new runtime.RequiredError(
                'projectId',
                'Required parameter "projectId" was null or undefined when calling shopTurnoverByDomainStatistics().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/v1/project/{projectId}/erp/shop-statistics/turnover-by-domain`;
        urlPath = urlPath.replace(`{${"projectId"}}`, encodeURIComponent(String(requestParameters['projectId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DateRangeInputToJSON(requestParameters['dateRangeInput']),
        };
    }

    /**
     * Returns shop performance data.
     */
    async shopTurnoverByDomainStatisticsRaw(requestParameters: ShopTurnoverByDomainStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<any>> {
        const requestOptions = await this.shopTurnoverByDomainStatisticsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<any>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Returns shop performance data.
     */
    async shopTurnoverByDomainStatistics(requestParameters: ShopTurnoverByDomainStatisticsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<any> {
        const response = await this.shopTurnoverByDomainStatisticsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
